export default __webpack_public_path__ + "static/media/character-yeti-happy.23e4fc27.png";